// src/lib/api/client.js
import axios from 'axios';
const domain = process.env.REACT_APP_domain;
const city = process.env.REACT_APP_City;
const fallbackCityId = process.env.REACT_APP_City_ID;

const api = axios.create();

const getLang = () => {
  if (typeof localStorage !== 'undefined') {
    return (localStorage.getItem('lang') || 'en').split('-')[0];
  }
  return 'en';
};

const getCityId = () => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('cityId') || fallbackCityId;
  }
  return fallbackCityId;
};

api.interceptors.request.use((config) => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('arab_user_token') : null;
  const baseURL = `https://${domain}/api/${city}/${getLang()}/${getCityId()}`;
  config.baseURL = config.baseURL || baseURL;
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
